import React, { useState, useEffect, useCallback } from "react";
import { Button } from '@material-ui/core';
import AddIcon from "@material-ui/icons/Add";
import UserItem from '../Users/components/UserItem';
import { useLocation } from "react-router-dom";
import ProfilesService from "../../../../services/ProfilesService";
import ScreenHeader from "../../components/ScreenHeader";
import { capitalize } from "../../../../utils/string";
import EmptyResult from "../../../components/EmptyResult";
import MainItem from "./components/MainItem";
import { makeStyles } from '@material-ui/core/styles';
import ModalAddNewUser from "../Users/modals/modalNewUser";


const useStyles = makeStyles((theme) => ({
  shortCuts: {
    marginTop: '3em',
    display: 'flex',
    justifyContent: 'space-between'
  }
}));

function Main(props){
  const classes = useStyles();
  const usersLoading = Array.from(Array(5).keys());
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModalAddNewUser, setOpenModalAddNewUser] = useState(false);
  const PROFILE = props.profile;

  // pagination
  const location = useLocation();

  // Get users data
  const fetchUsersData = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await ProfilesService.listProfiles({
        fields: "id,email,first_name,last_name,profile_type,phone,is_active",
        ordering: "-date_joined",
        limit: 3
      }, {
        profile: PROFILE
      });
      setUsers(result.data.results);
      setIsLoading(false);
    } catch (error) {
      setUsers([]);
    }
  }, [PROFILE]);

  useEffect(() => {
    // Query Params changued
    fetchUsersData();
  }, [fetchUsersData, location.search]);

  const updateItemsList = () => {
    fetchUsersData();
  };

  const removeUserFromList = userId => {
    const newUsers = users.filter((item, index) => item.id !== userId);
    setUsers(newUsers);
  };

  return (
    <div id="users-screen" className={`${props.className} dashboard-container`}>
      {/* Header */}
      <ScreenHeader title={`Users - Recenctly added`}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setOpenModalAddNewUser(true)}
          endIcon={<AddIcon />}
        >
          {" "}
          Add {capitalize(PROFILE) || 'User'}
        </Button>
        {/* <IconButton color="primary" aria-label="add course" component="span">
          <AddIcon />
        </IconButton> */}
      </ScreenHeader>

      {/* Body */}
      <div className="content">
        {isLoading ? (
            // Generate 5 courses of loading data
            usersLoading.map(i => <UserItem key={i} loading />)
          ) : // Show courses
          users.length > 0 ? (
            users.map(course => (
              <UserItem
                data={course}
                key={course.id}
                profile={PROFILE}
                removeItem={removeUserFromList}
                updateItemsList={updateItemsList}
                openSnack={props.openSnack}
              />
            ))
          ) : (
            // Show Empty courses
            <EmptyResult />
          )}

        <div className={classes.shortCuts}>
          <MainItem title="Group" description="This is the Group section" to={`/dashboard/courses`}/>
          <MainItem title="Users" description="Add users to groups" to={`/dashboard/courses-students`}/>
          <MainItem title="Modules" description="Task and assignments" to={`/dashboard/syllabus`}/>
        </div>        

      </div>

      <ModalAddNewUser
        open={openModalAddNewUser}
        onClose={() => setOpenModalAddNewUser(false)}
        updateItemsList={updateItemsList}
        profile={PROFILE}
      />
    </div>
  )
}

export default Main;